<div class="bg">
    <div class="container">
        <div class="row">
            <div class="col-md-6 offset-md-3">
                <div class="content-wrap">
                    <div class="col-md-12">
                        <div class="">
                            <div class="card-body">
                                <form>
                                    <p class="login-hd">Oops!</p>
                                    <p class="login-hd-main">404</p>
                                    <p class="login-line">Sorry, the page you are looking for is doesn't exist. You can get back to the home page using below link.</p>
                                    <button class="btn bg-theme form-btn"><a class="form-btn-link" routerLink="student">Go Back to Home page</a></button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


